import TabPage from "./../factories/tab-page";
import "./../bindings/bao-searcher";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
class Connector extends BaseViewModel {
    Name = ko.observable<string>("");
    Key = ko.observable<string>("");
    AuthenticationData = ko.observable<string>("");
    ConnectorTypeName = ko.observable<string>("");
    ConnectorTypeId = ko.observable<string>("");
    ConnectorTypeItem = ko.observable<any>();
    ConnectorTypeSearcherBinding = {
        ObjectId: this.ConnectorTypeId,
        ObjectValue: 'Name',
        SearchType: 'Bao-ConnectorType',
        AutoComplete: true,
        AutoSearch: true,
        SelectedItem: this.ConnectorTypeItem
    };
    ConnectorName = ko.observable<string>("");
    ConnectorTestId = ko.observable<string>("");
    ConnectorTestItem = ko.observable<any>();
    ConnectorSearcherBinding = {
        ObjectId: this.ConnectorTestId,
        ObjectValue: 'Name',
        SearchType: 'Bao-Connector',
        AutoComplete: true,
        AutoSearch: true,
        SelectedItem: this.ConnectorTestItem
    };
    public constructor(tabPage: TabPage) {
        super(tabPage);
    }
    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;
        if (this.Name() === "" || this.Name() === null) {
            completed = false;
        }
        if (this.ConnectorTypeId() === "" || this.ConnectorTypeId() === null) {
            completed = false;
        }
        if (this.Key() === "" || this.Key() === null) {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    public InitUrl(): string {
        return "BaoConnector/Init";
    }
    public init(): JQueryPromise<void> {
        return super.init();
    }
}
export default Connector;